// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__XffC9","title":"BackImages_title__TdC1A","images":"BackImages_images__3iIfX"};